import Swiper from 'swiper/bundle';
import './circle-progress';
import vars from '../helpers';
import {MotionPathPlugin} from 'gsap/MotionPathPlugin';

gsap.registerPlugin(MotionPathPlugin);

// Professions section
let $professionsDots = $('.professions__dots');
let $professionsSlider = $('.professions__slider');
let $professionsDot = $('.professions__dot');

const professionsDot = new Swiper($professionsDots[0], {
	direction: 'vertical',
	spaceBetween: 0,
	slidesPerView: 'auto',
	freeMode: true,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
	on: {
		resize: () => {
			$professionsDot.removeAttr('style');
			professionsDot.update();
		},
	},
});

const professionsSlider = new Swiper($professionsSlider[0], {
	spaceBetween: 10,
	speed: 500,
	direction: 'vertical',
	autoHeight: true,
	navigation: {
		nextEl: '.professions__next',
		prevEl: '.professions__prev',
	},
	thumbs: {
		swiper: professionsDot,
	},
	allowTouchMove: false,
});

professionsSlider.on('slideChangeTransitionStart', () => {
	let $professionsSlide = $('.professions__slide.swiper-slide-active');
	let $professionsSlideId = $professionsSlide.data('slide');
	let $professionsNext = $('.professions__next');
	let $professionsBg = $(`.home__professions .home__bg[data-id="${$professionsSlideId}"]`);

	$professionsBg.addClass('is-active');
	$professionsBg.prevAll().addClass('is-active');
	$professionsBg.nextAll().removeClass('is-active');

	$professionsNext.removeAttr('data-color');
	$professionsNext.attr('data-color', $professionsSlideId);

	vars.$document.trigger('slide-change-show', [5, 'professii']);
});

vars.$window.on('resize', () => {
	setTimeout(() => {
		professionsSlider.update();
		professionsSlider.updateSize();
		professionsSlider.updateSlides();
	}, 300);
})

// Stories section
let $storiesSlider = $('.stories__slider');

let storiesSlideChange = () => {
	let $storiesSlide = $('.stories__slide.swiper-slide-active');
	let $storiesSlideColor = $storiesSlide.data('slide');
	let $storiesSlideBg = $(`.home__stories .home__bg[data-id="${$storiesSlideColor}"]`);
	let $storiesPrev = $('.stories__prev');
	let $storiesNext = $('.stories__next');

	$storiesSlideBg.addClass('is-active');
	$storiesSlideBg.prevAll().addClass('is-active');
	$storiesSlideBg.nextAll().removeClass('is-active');
	$storiesPrev.attr('data-color', $storiesSlideColor);
	$storiesNext.attr('data-color', $storiesSlideColor);
};

const storiesSlider = new Swiper($storiesSlider[0], {
	spaceBetween: 0,
	effect: 'fade',
	loop: true,
	allowTouchMove: false,
	preventInteractionOnTransition: true,
	navigation: {
		nextEl: '.stories__next',
		prevEl: '.stories__prev',
	},
	on: {
		slideChangeTransitionStart: () => {
			storiesSlideChange();
			vars.$document.trigger('stories-slide-change');
			vars.$document.trigger('slide-change-show', [4, 'istorii']);
		},
	},
});

// Discoveries section
let $discoveriesSlider = $('.discoveries__slider');
let $discoveriesDots = $('.discoveries__dots');
let circleInitStart = false;

let circleProgress = (el, color) => {
	let colors = {
		color1: '#f5812c',
		color2: '#10adca',
		color3: '#fa142e',
		color4: '#d265ed',
		color5: '#28bc42',
		color6: '#ffac22',
		color7: '#1dded9',
	};

	$(el).circleProgress({
		value: 1,
		animation: {
			duration: 10000,
		},
		thickness: 2,
		size: 56,
		fill: {
			color: colors[`color${color}`],
		},
	});
};

let circleChange = () => {
	let $circleActive = $('.discoveries__dots .swiper-slide-thumb-active .discoveries__circle');
	let $slideColor = $circleActive.data('color');

	circleProgress($circleActive, $slideColor);
};

let discoveriesSliderChange = () => {
	let $discoveriesSlide = $('.discoveries__slide.swiper-slide-active');
	let $discoveriesSlideColor = $discoveriesSlide.data('slide');
	let $discoveriesNext = $('.discoveries__next');
	let $discoveriesBg = $(`.home__discoveries .home__bg[data-id="${$discoveriesSlideColor}"]`);
	let $discoveriesBgActive = $('.home__discoveries .home__bg.is-active');
	let $discoveriesBgNext = $(`.home__discoveries .home__bg[data-id="${$discoveriesSlideColor}"]`);;

	$discoveriesNext.removeAttr('data-color').attr('data-color', $discoveriesSlideColor);

	$discoveriesBg.addClass('is-active');
	$discoveriesBg.prevAll().addClass('is-active');
	$discoveriesBg.nextAll().removeClass('is-active');

	// if (!vars.isMobile()) {
	// 	gsap
	// 		.timeline()
	// 		.to([$discoveriesBgActive, $discoveriesBgNext], {
	// 			onComplete() {
	// 				$discoveriesBgActive.removeClass('is-active');
	// 				$discoveriesBgNext.addClass('is-active');
	// 			},
	// 			duration: 1,
	// 			scale: '3',
	// 			rotate: '-180',
	// 			x: '30vw',
	// 			y: '-30vh',
	// 			filter: 'blur(30px)',
	// 			ease: 'power2.in',
	// 		})
	// 		.to([$discoveriesBgActive, $discoveriesBgNext], {
	// 			duration: 0.7,
	// 			scale: '1',
	// 			rotate: '-360',
	// 			x: '0',
	// 			y: '0',
	// 			filter: 'blur(0px)',
	// 			ease: 'power3.out',
	// 			clearProps: true,
	// 		});
	// } else {
	// 	$discoveriesBg.addClass('is-active');
	// 	$discoveriesBg.prevAll().addClass('is-active');
	// 	$discoveriesBg.nextAll().removeClass('is-active');
	// }

	circleChange();
};

const discoveriesDot = new Swiper($discoveriesDots[0], {
	direction: 'vertical',
	speed: 500,
	spaceBetween: 0,
	slidesPerView: 7,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
	allowTouchMove: false,
});

const discoveriesSlider = new Swiper($discoveriesSlider[0], {
	spaceBetween: 0,
	effect: 'fade',
	autoplay: {
		delay: 10000,
		disableOnInteraction: false,
	},
	speed: 500,
	loop: true,
	navigation: {
		nextEl: '.discoveries__next',
		prevEl: '.discoveries__prev',
	},
	thumbs: {
		swiper: discoveriesDot,
	},
	allowTouchMove: false,
	preventInteractionOnTransition: true,
	on: {
		slideChangeTransitionStart: () => {
			vars.$document.trigger('discoveries-slide-change');
			vars.$document.trigger('slide-change-show', [3, 'otkrytiya']);

			discoveriesSliderChange();
		},
	},
});

let circleInit = () => {
	$('.discoveries__circle').circleProgress({
		value: 1,
		animation: {
			duration: 10000,
		},
		thickness: 2,
		size: 56,
		fill: {
			color: '#f5812c',
		},
	});
};

discoveriesSlider.autoplay.stop();

vars.$document.on('discoveries-slider-play', () => {
	discoveriesSlider.autoplay.start();

	circleChange();

	if (circleInitStart) {
		return;
	}

	circleInitStart = true;
	circleInit();
});

vars.$document.on('discoveries-slider-stop', () => {
	discoveriesSlider.autoplay.stop();
});

vars.$document.on('discoveries-slider-start', () => {
	discoveriesSlider.autoplay.start();
});

// Achievements section
let $achievementsSlider = $('.achievements__slider');
let $achievementsDots = $('.achievements__dots');
let $achievementsCircleNext = $('.achievements__circle--next');
let $achievementsObject = $('.achievements__object');
let $achievementsObjectWrapper = $('.achievements__object-wrapper');
let achievementsSlideCurrent = 0;
let achievementsDuration = 1.5;
let achievementPathStart = 0;
let achievementsTl = gsap.timeline();

let achievementsSlideChanged = (slideCurrent) => {
	let pointCurrent = `.achievements__point${slideCurrent}`;
	let $achievementPath = $(pointCurrent).data('path');
	let $achievementRotate = $(pointCurrent).data('rotate');

	achievementsTl.to('.achievements__object', {
		duration: achievementsDuration,
		yoyo: true,
		ease: 'power1.out',
		motionPath: {
			start: achievementPathStart,
			end: $achievementPath,
			path: '.achievements__path',
			align: '.achievements__path',
			autoRotate: true,
			alignOrigin: [0.5, 0.5],
		},
		onStart() {
			$achievementsObject.addClass(`is-rotate-${$achievementRotate}`);
			if (slideCurrent < achievementsSlideCurrent) {
				$achievementsObjectWrapper.addClass('is-rotate');
			} else {
				$achievementsObjectWrapper.removeClass('is-rotate');
			}
		},
		onComplete() {
			$achievementsObject.removeClass(`is-rotate-${$achievementRotate}`);
			achievementsSlideCurrent = slideCurrent;
		},
	}).to(pointCurrent, {
		duration: 0,
		opacity: 1,
	});

	achievementPathStart = $achievementPath;
};

let achievementsSlideFirst = (slideCurrent) => {
	let $achievementsWrapper = $('.achievements__wrapper');
	let $achievementsSlide2 = $('.achievements__slide[data-slide="2"]');
	let wrapperPosition = vars.$window.width() - $achievementsSlide2.width() - (vars.$window.width() - $achievementsSlide2.width()) / 2 - $achievementsSlide2.position().left;

	if (vars.isMobile()) {
		return;
	}

	if (!vars.isMobile() && slideCurrent === 0) {
		$achievementsSlider.attr('data-slide', '1');
	} else {
		$achievementsSlider.removeAttr('data-slide');
	}

	if (slideCurrent === 0) {
		$achievementsWrapper.css('transform', `translate3d(${wrapperPosition}px, 0px, 0px)`);
	}
};

const achievementsDot = new Swiper($achievementsDots[0], {
	spaceBetween: 0,
	slidesPerView: 9,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
});

const achievementsSlider = new Swiper($achievementsSlider[0], {
	spaceBetween: 0,
	slidesPerView: 'auto',
	slideToClickedSlide: true,
	allowTouchMove: false,
	preventInteractionOnTransition: true,
	speed: 1500,
	navigation: {
		nextEl: '.achievements__next',
		prevEl: '.achievements__prev',
	},
	thumbs: {
		swiper: achievementsDot,
	},
	on: {
		afterInit: () => {
			setTimeout(() => {
				achievementsSlideFirst(0);
			}, 250);
		},
		realIndexChange: () => {
			setTimeout(() => {
				achievementsSlideFirst(achievementsSlider.activeIndex);
			}, 50);
		},
		resize: () => {
			setTimeout(() => {
				achievementsSlideFirst(achievementsSlider.activeIndex);
				achievementsSlider.update();
				achievementsSlider.updateSize();
				achievementsDot.update();
				achievementsDot.updateSize();
			}, 500);
		},
	},
	breakpoints: {
		1025: {
			centeredSlides: true,
		}
	}
});

achievementsSlider.on('slideChangeTransitionStart', () => {
	let $achievementsSlide = $('.achievements__slide.swiper-slide-active');
	let $achievementsSlideColor = $achievementsSlide.data('slide');
	let $achievementsArrow = $('.achievements__prev, .achievements__next');

	$achievementsArrow.removeAttr('data-color').attr('data-color', $achievementsSlideColor);

	vars.$document.trigger('achievements-slide-change');

	achievementsSlideChanged(achievementsSlider.activeIndex);
	vars.$document.trigger('slide-change-show', [2, 'dostizheniya']);
});

vars.$document
	.on('professions-slide-next', () => {
		professionsSlider.slideNext();
	})
	.on('professions-slide-prev', () => {
		professionsSlider.slidePrev();
	})
	.on('professions-slider-update', () => {
		professionsSlider.update();
		professionsSlider.updateSize();
		professionsSlider.updateSlides();
	})
	.on('stories-slide-next', () => {
		storiesSlider.slideNext();
	})
	.on('stories-slide-prev', () => {
		storiesSlider.slidePrev();
	})
	.on('discoveries-slide-next', () => {
		discoveriesSlider.slideNext();
	})
	.on('discoveries-slide-prev', () => {
		discoveriesSlider.slidePrev();
	})
	.on('achievements-slide-next', () => {
		achievementsSlider.slideNext();
	})
	.on('achievements-slide-prev', () => {
		achievementsSlider.slidePrev();
	})
	.on('achievements-slide-first', () => {
		achievementsSlider.update();
		achievementsSlideFirst(achievementsSlider.activeIndex);
	})

$achievementsCircleNext.on('click', () => {
	achievementsSlider.slideNext();
});
